import { useEffect, useState } from 'react';
//@ts-expect-error untyped import
import ColorPickerPopoverBody from 'react-colorpicker/popover/ColorPickerPopoverBody';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { ColorSquatch } from 'foundations-components/transitional/components/ColorSquatch';
import debounce from 'react-utils/debounce';
import { ColorSquatchGrid } from 'foundations-components/transitional/components/ColorSquatchGrid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ColorPicker = ({
  value,
  onChange,
  resetValue,
  grid,
  size,
  index = 0,
  children
}) => {
  const [open, setOpen] = useState(false);
  const [pickerMode, setPickerMode] = useState();
  const [draftColor, setDraftColor] = useState(value);
  const debouncedSetDraftColor = debounce(setDraftColor, 4);
  const debouncedOnChange = debounce(onChange, 250);
  const handleOnChange = ({
    color
  }) => {
    debouncedSetDraftColor(color);
    debouncedOnChange(color);
  };
  useEffect(() => {
    setDraftColor(value);
  }, [value]);
  const popoverContent = /*#__PURE__*/_jsx(ColorPickerPopoverBody, {
    colorGrid: grid,
    color: draftColor,
    onChange: handleOnChange,
    onResetClick: () => handleOnChange({
      color: resetValue
    }),
    pickerMode: pickerMode,
    onPickerModeChange: e => {
      setPickerMode(e.target.value);
    }
  });
  return /*#__PURE__*/_jsx(Popover, {
    onOpenChange: ({
      target: {
        value: updatedOpenValue
      }
    }) => {
      setOpen(updatedOpenValue);
    },
    open: open,
    content: popoverContent,
    children: /*#__PURE__*/_jsxs(ColorSquatchGrid, {
      children: [/*#__PURE__*/_jsx(ColorSquatch, {
        "data-test-id": `color-picker-current-color-squatch-${index}`,
        color: draftColor,
        onClick: () => {
          setOpen(prev => !prev);
        },
        size: size
      }), children]
    })
  });
};
export default ColorPicker;